module.exports = __webpack_public_path__ + "static/img/inquire.7f113f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/inquire.jpg
// module id = 96
// module chunks = 1